import React, { useEffect } from 'react';
import { Outlet, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from './components/NavBar/NavBar';
import Footer from './components/Footer/Footer';

const supportedLanguages = ['en', 'zh'];

const Layout = () => {
  const { lng } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!supportedLanguages.includes(lng)) {
      navigate(`/en`, { replace: true });
    } else {
      i18n.changeLanguage(lng);
    }
  }, [lng, i18n, navigate]);

  return (
    <>
      <Navbar />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;